import {settingHttp} from './index'

function settingRequest(url, method, data) {
    return settingHttp({
        url: url,
        method: method,
        data: data
    })
}

function get(url, data) {
    return settingRequest(url, 'get', data)
}

function post(url, data) {
    return settingRequest(url, 'post', data)
}

export function deleteApp(id) {
    return get('/app/deleteApp/' + id)
}

export function saveApp(data) {
    return post('/app/editApp', data)
}

export function searchApp(data) {
    return post('/app/searchApp', data)
}

export function deleteCompany(id) {
    return get('/company/deleteCompany/' + id)
}

export function saveCompany(data) {
    return post('/company/editCompany', data)
}

export function searchCompany(data) {
    return post('/company/searchCompany', data)
}

export function companyTrans() {
    return get('/company/trans')
}

export function mediaTrans(type) {
    return get('/media/trans/'+type)
}